import { Fade, Slide, LinearProgress } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { alertRef } from '../../../App';
import CheckBox from '../../../Components/CheckBox/CheckBox';
import Dropdown from '../../../Components/Dropdown/Dropdown';
import Modal from '../../../Components/Modal/Modal';
import { Button, Input } from '../../../Components/StyledComponents';
import './MenuSoldout.scss';

const MenuSoldout = () => {
    const [ isDrag, setIsDrag ] = React.useState(false)
    const [ list, setList ] = React.useState([])//메뉴 그룹 목록
    const [ soldoutTime, setSoldoutTime ] = React.useState(1)//품절 해제일 index
    const [ options ,setOptions ] = React.useState([])//품절 해제일 options
    const [ hour, setHour ] = React.useState({});//운영 시간
    const [ selected, setSelected ] = React.useState();//선택된 메뉴 정보
    const [ isLoading, setIsLoading ] = React.useState(true)
    const modalRef = React.useRef(null);

    useEffect(() => {
        getMenuGroup();
        getOperationInfo();
    },[])
    useEffect(()=>{
        getTimeOptions();
    }, [hour]);

    //메뉴 품절 설정
    const setMenuSoldOut = (gid,id) => {
        axios.patch('/api/order/menu/sold_out/' + gid + '/' + id )
        .then((data) => {
            if(data.status === 204){
                getMenuGroup()
                alertRef.current.showAlert({ title : '품절 설정이 완료 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //메뉴 품절 해제
    const deleteMenuSoldOut = (gid,id) => {
        axios.delete('/api/order/menu/sold_out/' + gid + '/' + id )
        .then((data) => {
            if(data.status === 204){
                getMenuGroup()
                alertRef.current.showAlert({ title : '품절 설정이 해제 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //메뉴 품절 해제일 변경
    const changeRestockDate = () => {
        axios.patch('/api/order/menu/restock/' + selected.gid + '/' + selected.id,{
            DaysLeft : soldoutTime
        })
        .then((data) => {
            if(data.status === 204){
                getMenuGroup()
                modalRef.current.closeModal()
                alertRef.current.showAlert({ title : '품절 해제일이 변경되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //운영시간 정보 get
    const getOperationInfo = () => {
        axios.get('/api/order/info/operation_hours')
        .then((data) => {
            setHour(data.data.OrderInfo.OperationHours)
        })
    }

    //품절 해제일 Option 생성
    const getTimeOptions = () => {
        let today = new Date();
        let time = '09:00';
        let satTime = '09:00';
        let sunTime = '09:00';


        if( typeof hour !== 'undefined' && Object.keys(hour).length > 0){
            if(!hour.Weekday.Allday){
                time = String(hour.Weekday.OpenHour).padStart(2,'0') + ':' + String(hour.Weekday.OpenMin).padStart(2,'0')
            }
            sunTime = time
            satTime = time

            if(!hour.Everyday){
                if( !hour.Saturday.Allday ) satTime = String(hour.Saturday.OpenHour).padStart(2,'0') + ':' + String(hour.Saturday.OpenMin).padStart(2,'0')
                else satTime = '09:00';
                if( !hour.Sunday.Allday )sunTime = String(hour.Sunday.OpenHour).padStart(2,'0') + ':' + String(hour.Sunday.OpenMin).padStart(2,'0')
                else sunTime = '09:00';
            }
        }
        let arr = [];
        for( let i = 1; i < 8; i++){
            let newDay = moment(today).add(i, 'days');
            let newTime = time;
            if(newDay.day() === 6) newTime = satTime
            else if(newDay.day() === 0) newTime = sunTime

            arr.push({
                key : moment(today).add(i, 'days').format('YYYY-MM-DD(dd)') + ` ${newTime}에 해제`,
                value : i
            })
        }
        setOptions(arr)
    }

    //메뉴 그룹 목록 get
    const getMenuGroup = () => {
        setIsLoading(true)
        axios.get('/api/order/menu/group')
        .then((data) => {
            setList(data.data)
            setIsLoading(false)
        })
        .catch(() => {
            setIsLoading(false)
        })
    }

    return (
        <div className='menu-soldout-info'>
            {/* <div className='header-row between'>
                <Input
                    style={{ width : 400 }}
                    placeholder="메뉴를 검색해보세요."
                />

                <div className='row'>
                    <Button variant="sub" small style={{ marginRight : 8, width : 112 }} onClick={() => setIsDrag(old => !old)}>
                        {isDrag ? '취소' : '선택하기'}
                    </Button>

                    {
                        isDrag ?
                        <Button variant="main" small style={{ width : 112 }} onClick={() => modalRef.current.openModal()}>
                            순서 저장
                        </Button>
                        :
                        null
                    }
                </div>
            </div>

            <div className='divider'></div> */}

            {
                isLoading ?
                <LinearProgress color="error" />
                :
                null
            }


            {
                isLoading ?
                null
                :
                list.length > 0 ?
                list.map((data,i) =>(
                    <div className='menu-group-box' key={i}>
                        <div className='row'>
                            <p className='menu-group-name'>{data.Name}</p>
                        </div>

                        {
                            data.MenuInfo.map((item,i) => {
                                return(
                                    <div key={i}>
                                        <div className='row between'>
                                            <div className='row'>
                                                <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration : '0.4s' }}>
                                                    <p className='move-icon' style={{ width : isDrag ? 64 : 0, transition : 'all', transitionDuration : '0.3s' }}>
                                                        <CheckBox containerStyle={{ width : 64, margin : 0, height : 24 }}/>
                                                    </p>
                                                </Slide>
                                                <div>
                                                    <p className='menu-name'>{item.Name}</p>
                                                    {
                                                        item.isSoldOut &&
                                                        <div className='row' style={{ marginTop : 12 }}>
                                                            <div className='soldout-box'>
                                                                품절
                                                            </div>
                                                            <p className='soldout-text'>{moment(item.RestockDate.$date).utc().local('ko').format('YYYY-MM-DD(dd) HH:mm')} 에 자동으로 해제되어 판매 가능해요</p>
                                                            <p className='change-soldout' onClick={() => {setSelected({gid : data._id.$oid, id : item._id.$oid});modalRef.current.openModal()} }>품절 해제일 변경</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className='row' style={{ alignItems : 'center', justifyContent : 'center', opacity : isDrag ? 0 : 1, transition : 'all', transitionDuration : '0.5s' }}>
                                                {
                                                    item.isSoldOut ? 
                                                    <Button variant='outline' small style={{ width : 88, borderColor : '#3d9822', color : '#3d9822' }} className='out-btn' onClick={() => alertRef.current.showAlert({ title : `해당 메뉴를 품절 해제 할까요?`, isConfirm : true, confirmText : '해제하기', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();deleteMenuSoldOut(data._id.$oid,item._id.$oid)} })}>
                                                        품절해제
                                                    </Button>
                                                    :
                                                    <Button variant='outline' small style={{ width : 88 }} onClick={() => alertRef.current.showAlert({ title : `메뉴를 품절 상태로 변경할까요?`, subTitle : '품절 상태로 변경되면 주문 페이지에서 해당 메뉴가 보이지 않아요.', isConfirm : true, confirmText : '변경하기', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();setMenuSoldOut(data._id.$oid,item._id.$oid)} })}>
                                                        품절
                                                    </Button>
                                                }
                                            </div>
                                        </div>
                                        {
                                            i !== data.MenuInfo.length - 1 &&
                                            <div className='divider' />
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                ))
                :
                <div>
                    <p className='empty-list'>생성된 메뉴가 없습니다.</p>
                </div>
            }

            <Modal ref={modalRef} contentContainer={{width : 500}} isHeader title='품절 해제일 변경'>
                <>
                    <div>
                        <p className='label' style={{ width : 'fit-content'}}>품절 해제 시간</p>
                        <Dropdown
                            width={420}
                            options={options}
                            btnStyle={{ marginTop : 24, marginBottom : 12 }}
                            value={ options.length > 0 ? options[soldoutTime - 1].key : ''}
                            onItemClick={(val) => setSoldoutTime(val)}
                        />
                    </div>
                    <p className='warn-soldout'>* 품절은 가게 운영 시작시간에 맞춰 해제됩니다.</p>

                    <div className='btn-row'>
                        <Button variant="main" className='save-btn' fontSize={16} onClick={() => alertRef.current.showAlert({ title : `옵션을 품절 일자를 변경할까요?`, subTitle : '설정하신 날짜에 자동으로 품절이 해제되어 판매 가능해요.', isConfirm : true, confirmText : '변경하기', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();changeRestockDate()} })}>
                            변경하기
                        </Button>
                    </div>
                </>
            </Modal>
        </div>
    )
}

export default MenuSoldout;